import React from 'react';
const testimonials = [{
  initials: 'FL',
  stars: 5,
  quote: 'Mis pibes de 10 años finalmente entienden el sistema. El Tomo 4 con el rombo y las transiciones es extraordinario.',
  name: 'Fernando L.',
  loc: 'Tucumán'
}, {
  initials: 'VT',
  stars: 5,
  quote: 'El Bono 3 de Sin Filas Sin Caos me cambió la vida. Los 20 códigos de voz son algo que no sabía que necesitaba.',
  name: 'Valentina T.',
  loc: 'Santa Fe'
}, {
  initials: 'PA',
  stars: 5,
  quote: 'Fue la primera vez en años que un padre me agradeció el informe en vez de quejarse. Vale el pack solo por eso.',
  name: 'Pablo A.',
  loc: 'Neuquén'
}, {
  initials: 'SC',
  stars: 5,
  quote: 'Encontré exactamente lo que le falta al pibe argentino: pelota en los pies desde el minuto 1. No quieren irse.',
  name: 'Santiago C.',
  loc: 'La Plata'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-[#0a0a0a] py-12 px-4" data-id="element-238">
      <div className="max-w-4xl mx-auto" data-id="element-239">
        <h2 className="text-2xl sm:text-3xl font-black text-white text-center mb-2" data-id="element-240">
          Más testimonios de profes
          <br data-id="element-241" />
          <span className="text-[#00C853]" data-id="element-242">que ya tienen su MegaPack:</span>
        </h2>
        <p className="text-gray-400 text-sm text-center mb-8" data-id="element-243">
          +500 profes de Argentina ya lo usan
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-244">
          {testimonials.map((t, i) => <div key={i} className="bg-black border border-[#00C853]/20 rounded-xl p-5 flex flex-col gap-3" data-id="element-245">
              <div className="flex items-center gap-3" data-id="element-246">
                <div className="w-8 h-8 rounded-full bg-[#00C853]/20 border border-[#00C853]/40 flex items-center justify-center text-[#00C853] font-bold text-xs flex-shrink-0" data-id="element-247">
                  {t.initials}
                </div>
                <div data-id="element-248">
                  <div className="text-[#00C853] text-xs mb-0.5" data-id="element-249">
                    {'⭐'.repeat(t.stars)}
                  </div>
                  <div className="text-white font-bold text-sm leading-none" data-id="element-250">
                    {t.name}
                  </div>
                  <div className="text-gray-500 text-[10px] mt-1" data-id="element-251">
                    📍 {t.loc}
                  </div>
                </div>
              </div>
              <p className="text-gray-300 text-sm leading-snug italic" data-id="element-252">
                "{t.quote}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}